import {combineReducers} from 'redux';

import notificationSettings from './notification-settings/reducer';
import conversationSettings from './conversation-settings/reducer';
import feedSettings from './feed-settings/reducer';
import accountDetails, {type AccountDetailsState} from './account-details/reducer';
import notificationHoursSettings, {type NotificationHoursSettingsState} from './notification-hours-settings/reducer';

export interface AccountSettingsState {
    notificationSettings: any;
    conversationSettings: any;
    feedSettings: any;
    accountDetails: AccountDetailsState;
    notificationHoursSettings: NotificationHoursSettingsState;
}

export default combineReducers<AccountSettingsState>({
    notificationSettings,
    conversationSettings,
    feedSettings,
    accountDetails,
    notificationHoursSettings,
});
